import React, {Component} from 'react';
import {Dropdown} from 'semantic-ui-react'

class RAsistencia extends Component{

	constructor(props){
        super(props);
        if (this.props.sueldos) {
            this.sueldos = Object.keys(this.props.sueldos).map((nombre, index) => ({
                key: index,
                text: nombre,
                value: this.props.sueldos[nombre],
              }))
              
        } else {
            this.sueldos = ["ninguno"]
        }
        this.state = {
            fecha: this.props.fecha,
			empleado: this.props.empleado,
            falta: "no",
			hEntrada: "07:00:00",
            hSalida: "15:00:00",
            pagoXhoras: "no",
            ventana: "open",
            base1: 0,
            sueldo1: 0,
            horas1: 0,
            puesto1: '',
            base2: 0,
            sueldo2: 0,
            horas2: 0,
            puesto2: '',
            baseE: 0,
            sueldoE: 0,
            horasE: 0,
            puestoE: '',
            precio: 0,
		};
	}
	handleUserInput = (event) => {
		this.setState({
			[event.target.name]: event.target.value
        })
    }
    sueldo1 = (e, {value}) => {
        this.setState({
            puesto1: e.target.textContent,
            base1: value
        })
    }
    sueldo2 = (e, {value}) => {
        this.setState({
            puesto2: e.target.textContent,
            base2: value
        })
    }
    hExtra = (e, {value}) => {
        this.setState({
            puestoE: e.target.textContent,
            baseE: value
        })
    }

    actualizarSueldos = () => {
        if (this.state.base1 > 0 && this.state.horas1 > 0){
            this.setState({
                sueldo1: this.state.base1 * this.state.horas1,
            })
        }
        if (this.state.base2 > 0 && this.state.horas2 > 0){
            this.setState({
                sueldo2: this.state.base2 * this.state.horas2,
            })
        }
        if (this.state.baseE > 0 && this.state.horasE > 0){
            this.setState({
                sueldoE: this.state.baseE * this.state.horasE,
            })
        }
        this.setState({
            precio: this.state.sueldo1 + this.state.sueldo2 + this.state.sueldoE,
        })
        if (this.state.precio > 0){
            this.writeNew()
        } else {
            alert("La suma de los sueldos tiene que ser mayor a 0")
        }
    }
	writeNew = () => {
		const data = {...this.state};
		this.props.newRegistro(data);
		this.setState({
            falta: 'no',
			hEntrada: "07:00:00",
            hSalida: "15:00:00",
            pagoXhoras: 'no',
            ventana: "close",
            sueldo1: 0,
            horas1: 0,
            puesto1: '',
            sueldo2: 0,
            horas2: 0,
            puesto2: '',
            sueldoE: 0,
            horasE: 0,
            puestoE: '',
            precio:0,
		})
	}

	render(){
    if(this.state.ventana === "open"){
        let sueldoHoras;
        let formulario;
        if (this.state.pagoXhoras === "si") {
            sueldoHoras = 
            <>
                <div className='SelectContainer'>
                    <Dropdown 
                        compact
                        selection
                        placeholder='Sueldo 1'
                        options={this.sueldos}
                        onChange={this.sueldo1}
                    />
                    <input placeholder='Horas a pagar' type='number' name='horas1' onChange={this.handleUserInput}/>
                </div>
                <div className='SelectContainer'>
                    <Dropdown 
                        compact
                        selection
                        placeholder='Sueldo 2'
                        options={this.sueldos}
                        onChange={this.sueldo2}
                    />
                    <input placeholder='Horas a pagar' type='number' name='horas2' onChange={this.handleUserInput}/>
                </div>
                <div className='SelectContainer'>
                    <Dropdown 
                        compact
                        selection
                        placeholder='Horas Extra'
                        options={this.sueldos}
                        onChange={this.hExtra}
                    />
                    <input placeholder='Horas a pagar' type='number' name='horasE' onChange={this.handleUserInput}/>
                </div>
            </>
            }
        if (this.state.falta === "no") {
            formulario = <div>
            <div className="input">Entrada: <input type='time' name='hEntrada' required={true} defaultValue={this.state.hEntrada} onChange={this.handleUserInput}/></div>
                <div className="input">Salida: <input type='time' name='hSalida' required={true} defaultValue={this.state.hSalida} onChange={this.handleUserInput}/></div>
                <div className="input">Sueldo por Dia?
                    <select name='pagoXhoras' value={this.state.pagoXhoras} onChange={this.handleUserInput}>            
                        <option value="no">NO</option>
                        <option value="si">SI</option>
                    </select>
                </div>
                    {sueldoHoras}
        </div>
        } else { formulario = <div>El empleado tiene falta.</div>;}

		return(
			<div>
				<form onSubmit={this.actualizarSueldos}>
                    <div className='divrowH'>
                        <p>{this.state.empleado}</p>
                        <p className="input">
                            <span className='inputItem'>Faltó? </span>
                            <select name='falta' 
                                value={this.state.falta} 
                                onChange={this.handleUserInput}>            
                                <option value="no">NO</option>
                                <option value="falta">SI</option>
                            </select>
                        </p>
                    </div>
					<div className='divrow'>
                        {formulario}
                    </div>

					<p><button type="submit">Guardar</button></p>
				</form>
			</div>
		)
	}else{return(<div>Empleado: {this.state.empleado} agregado.</div>)}}
}

export default RAsistencia;